import {
  filter,
  map,
  observeOn,
  switchMap,
  withLatestFrom,
  tap,
  mergeMap
} from 'rxjs/operators'
import { history } from '../store'
import Actions from '../actions'
import { getPayload } from '../utils/rxUtils'
import { asyncScheduler, of } from 'rxjs'
import routes from 'consts/routes'
import { getRouteByStepDone, isOEP } from 'utils/generalUtils'
import { getBackRoutes } from 'consts/flowConsts'
import {
  getParameterFromURL,
  shouldRequstData,
  shouldRedirectToWelcomeHomeScreen,
  isWelcomeBackRoute
} from 'utils/routingUtils'
import { LAYOUT_TYPE } from 'consts'
import { concatUrlSearchParams, ROUTE_STEP } from 'consts/flowConsts'

const dispatchNavigatedAction = map(payload =>
  Actions.createAction(Actions.NAVIGATION_CHANGED, payload)
)

export const navigateBack = action$ =>
  action$.pipe(
    getPayload(Actions.NAVIGATED_BACK),
    map(() => {
      history.back()
    }),
    dispatchNavigatedAction
  )

export const rememberLayoutOnRefresh = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.NAVIGATED_HOME),
    filter(({ layout }) => layout),
    map(({ layout }) =>
      Actions.createAction(
        Actions.NAVIGATED_TO,
        concatUrlSearchParams({ layout })(routes.ROOT)
      )
    )
  )

export const navigateTo = (action$, state$) => {
  return action$.pipe(
    getPayload(Actions.NAVIGATED_TO),
    // Put on micro task queue, so we let the appnavigator update b4 changing route
    observeOn(asyncScheduler),
    withLatestFrom(state$),
    map(([payload, state]) => {
      // If the route is enroll we need to add the application_id to the url (from store)
      if (payload?.includes(routes.ENROLL)) {
        const applicationId = state.application.applicationId
        history.push(
          concatUrlSearchParams({
            application_id: applicationId
          })(payload)
        )
      } else {
        history.push(payload)
      }
    }),
    dispatchNavigatedAction
  )
}

// blocked from user to navigation straith to urls that are not allowed
export const blockUserToRedirectToMessagePagesUrl = action$ => {
  return action$.pipe(
    getPayload(Actions.LOCATION_CHANGED),
    filter(
      payload =>
        payload?.action === 'POP' &&
        payload?.location?.pathname === routes.STATE_NOT_ALLOWED
    ),
    switchMap(() => of(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT)))
  )
}

export const blockUserToRedirectBackFromSuccess = (action$, state$) => {
  return action$.pipe(
    getPayload(Actions.LOCATION_CHANGED),
    filter(
      payload =>
        payload?.action === 'POP' &&
        payload?.location?.pathname === routes.ENROLL_FINALIZE
    ),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(state => state.application.isFlowCompleted),
    switchMap(() => of(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT)))
  )
}


export const redirectToHomeScreen = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.APP_LAUNCHED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(shouldRedirectToWelcomeHomeScreen),
    map(() => Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
  )

export const LoadOnRefresh = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.APP_LAUNCHED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(state => !isWelcomeBackRoute(state)),
    filter(shouldRequstData),
    map(state => getParameterFromURL(state, 'application_id')),
    mergeMap(applicationId => [
      Actions.createAction(Actions.APPLICATION_DATA_REQUESTED, {
        applicationId
      }),
      Actions.createAction(Actions.APPLICATION_RELOADED, {
        origin: 'application_reloaded'
      })
    ])
  )

export const navigateToRootOnStepSaved = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.STEP_FORWARD_NAVIGATED),
    filter(({ step }) => step),
    withLatestFrom(state$),
    map(([{ step }, { app }]) =>
      getRouteByStepDone({ step, isOEP: isOEP(app?.appConfig) })
    ),
    map(route => Actions.createAction(Actions.NAVIGATED_TO, route))
  )

export const loadApplicationEpic = (action$, state$) =>
  action$.pipe(
    getPayload(
      Actions.WELCOME_BACK_RECEIVED,
      Actions.BROKER_WELCOME_BACK_RECEIVED
    ),
    switchMap(({ route, applicationId }) => {
      return action$.pipe(
        getPayload(Actions.APPLICATION_DATA_RECEIVED),
        withLatestFrom(state$),
        tap(([{ data }, { app }]) => {
          if (!route) {
            route = data?.step
          }
          // Lets push all the previous routes to the history
          // so when we will navigate back itll be there
          const backroutes = getBackRoutes({
            currentRoute: route,
            isOEP: isOEP(app?.appConfig)
          }).map(concatUrlSearchParams({ application_id: applicationId }))
          backroutes.forEach(route => history.push(route))
        }),
        map(() =>
          Actions.createAction(
            Actions.NAVIGATED_TO,
            `${routes.ENROLL}/${route}`
          )
        )
      )
    })
  )

export const navOnLogOut = action$ =>
  action$.pipe(
    getPayload(Actions.LOGOUT_RECEIVED),
    mergeMap(() => {
      history.replace(routes.ROOT)
      return [
        Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT),
        Actions.createAction(Actions.TIMEOUT_MODAL_CLOSED)
      ]
    })
  )
